import script from "./selectHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./selectHouse.vue?vue&type=script&setup=true&lang=js"

import "./selectHouse.vue?vue&type=style&index=0&id=b5ff33c8&lang=scss&scoped=true"

import exportComponent from "/Users/luoxuelin/Workspace/idea/wnzhfc/s-pages/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5ff33c8"]])

export default __exports__